
/**
 * Rutas de Personas
 * Gestión de personas: empleados, asignaciones, asistencia, evaluaciones
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import TablaEmpleados from '../pages/personas/empleados/TablaEmpleados.jsx'
import Asistencia from '../pages/personas/attendance/Asistencia.jsx'
import Asignaciones from '../pages/personas/assignments/Asignaciones.jsx'
import AsignacionPersonal from '../pages/personas/assignments/AsignacionPersonal.jsx'
import SalidasEspeciales from '../pages/personas/exceptions/SalidasEspeciales.jsx'
import Evaluaciones from '../pages/personas/evaluations/Evaluaciones.jsx'
import LaborCalendario from '../pages/personas/calendario/LaborCalendario.jsx'
import ControlHoras from '../pages/personas/horas/ControlHoras.jsx'

export const personasRoutes = [
  <Route 
    key="calendario-labor" 
    path="/calendario-labor" 
    element={
      <ProtectedRoute>
        <LaborCalendario />
      </ProtectedRoute>
    } 
  />,
 
  <Route 
    key="empleados" 
    path="/empleados" 
    element={
      <ProtectedRoute>
        <TablaEmpleados />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="asistencia" 
    path="/asistencia" 
    element={
      <ProtectedRoute>
        <Asistencia />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="asignaciones" 
    path="/asignaciones" 
    element={
      <ProtectedRoute>
        <Asignaciones />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="asignacion-personal" 
    path="/asignacion-personal" 
    element={
      <ProtectedRoute>
        <AsignacionPersonal />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="salidas-especiales" 
    path="/salidas-especiales" 
    element={
      <ProtectedRoute>
        <SalidasEspeciales />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="control-horas" 
    path="/control-horas" 
    element={
      <ProtectedRoute>
        <ControlHoras />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="evaluaciones" 
    path="/evaluaciones" 
    element={
      <ProtectedRoute>
        <Evaluaciones />
      </ProtectedRoute>
    } 
  />,
]
